const actualRegion = () => {
    return new Promise(async (resolve, reject) => {
        let region_request = await fetch(`${process.env.REACT_APP_LICENCE_API}/check_region`, {method:'GET'})
        let actual_region = await region_request.json()
        resolve(actual_region)
    })
}

export default actualRegion